module.exports=function(scope){ return `<!-- enrollmentIdentifier found in database -->
{
    "meta": {
        "code": 200,
        "ok": true,
        "message": "The entry in the database for this enrollmentIdentifier was successfully deleted."
    }
}

<!-- enrollmentIdentifier not found in database -->
{
    "meta": {
        "code": 400,
        "ok": false,
        "message": "No entry found in the database for this enrollmentIdentifier."
    }
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/standard-server/response/success/enrollment-delete.json.tpl